const SMPQuestDefaultStrategy = require("@/quest-editor/questImpl/strategies/SMPQuestDefaultStrategy");
const HeroRankType = require("@/quest-editor/constants/HeroRankType");

class SMPQuestHeroReachRankStrategy extends SMPQuestDefaultStrategy {

     increaseKPIGameplayReference() {
          this.questContext.KPIGameplayBossLevel += this.questContext.JumpingLevel;
     }

     computeChallenge() {
          if (this.questContext.challengeTarget < HeroRankType.Platinum) {
               this.questContext.challengeTarget += 1;
          }
     }

     computeLevelShouldAppear () {
          let shouldAppearAt = this.questContext.KPIGameplayBossLevel - 100;
          if (shouldAppearAt < 1) shouldAppearAt = 100;
          this.questContext.KPIGameLevelShouldAppear = shouldAppearAt;
     }
}

module.exports = SMPQuestHeroReachRankStrategy